import { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAlbum, getAlbumDetail, resetAlbumDetail } from "./../../../pages/Album/redux/actions"
import { getRecommendVideo } from "./../../../pages/Home/redux/actions"

export const useAlbum = (params) => {
  const dispatch = useDispatch();
  const { albums, isProcessing, lastPage, currentPage } = useSelector(state => state.albumReducers);
  useEffect(() => {
    dispatch(getAlbum(params));
  }, [params, dispatch, getAlbum]);

  return [albums, isProcessing, lastPage, currentPage]
};

export const useAlbumDetail = (id) => {
  const dispatch = useDispatch();
  const { item, isProcessingItem } = useSelector(state => state.albumReducers);

  useEffect(() => {
    if (id) {
      dispatch(getAlbumDetail({id}));
    }
  }, [id, dispatch, getAlbumDetail]);

  return [item, isProcessingItem]
};

export const useRecommendVideo = (params) => {
  const dispatch = useDispatch();
  const { recommend_videos } = useSelector(state => state.homeReducers);

  useEffect(() => {
    dispatch(getRecommendVideo(params));
  }, [params, dispatch, getAlbum]);

  return [recommend_videos]
};

export const useResetAlbumDetail = (params) => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => dispatch(resetAlbumDetail());
  }, [dispatch]);
};

